import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-select.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-select.component.css?ngResource";
import { Component, forwardRef, Input } from '@angular/core';
import { UntypedFormBuilder, NG_VALUE_ACCESSOR } from "@angular/forms";
let CalciteSelectComponent = class CalciteSelectComponent {
    formBuilder;
    selectForm;
    inputLabelText = "";
    selectOptions = [];
    val;
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.selectForm = this.formBuilder.group({
            calciteSelectFormControl: []
        });
    }
    get value() {
        return this.selectForm?.value;
    }
    set value(val) {
        if (val && val.length > 0) {
            val.forEach(value => {
                this.selectOptions.push(value);
            });
        }
        this.val = val;
        this.onChange(val);
        this.onTouch(val);
    }
    ngOnInit() {
        this.initialiseForm();
    }
    onChange = () => {
    };
    onTouch = () => {
    };
    // sets the value programmatically
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    initialiseForm() {
        this.selectForm = this.formBuilder.group({
            calciteSelectFormControl: []
        });
    }
    static ctorParameters = () => [
        { type: UntypedFormBuilder }
    ];
    static propDecorators = {
        inputLabelText: [{ type: Input }],
        selectOptions: [{ type: Input }]
    };
};
CalciteSelectComponent = __decorate([
    Component({
        selector: 'lib-calcite-select',
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CalciteSelectComponent),
                multi: true
            }
        ],
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteSelectComponent);
export { CalciteSelectComponent };
